<template>
  <main-sidebar :name="name" :title="$t('filters')">
    <div class="p-4">
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('status') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.status"
            multiple
            :options="statusList"
            class="w-full"
            :reduce="(status) => status.id"
            label="name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('company') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.company"
            multiple
            :options="companyList"
            class="w-full"
            :reduce="(company) => company.id"
            label="name"
            @input="clearClientSelect"
          />
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select
            v-model="filters.client"
            multiple
            :options="filterClients"
            class="w-full"
            :reduce="(client) => client.ClientId"
            label="ClientName"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-2 mt-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('vendor') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <v-select 
          label="name" 
          :filterable="false" 
          :options="vendorList" 
          @search="onSearchVendors"   
          v-model="filters.vendor" 
          class="w-full" 
          multiple  
          ></v-select>
        </vs-col>
      </vs-row>


      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <input-date
            v-model="filters.start_date"
            :label="$t('start_date')"
            :onlyNewerYear="false"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <input-date
            v-model="filters.end_date"
            :label="$t('end_date')"
            :onlyNewerYear="false"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="mb-4">
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <label>{{ $t('folio') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="flex-start"
          vs-align="center"
          vs-w="12"
        >
          <vs-input class="w-full" v-model="filters.folio"></vs-input>
        </vs-col>
      </vs-row>
    </div>

    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="setFilter">
        {{ $t('apply_filters') }}
      </vs-button>
      <vs-button color="primary" type="border" @click="clear">
        {{ $t('clear_filters') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>

<script>
import MainSidebar from '@/views/components/MainSidebar.vue'
import InputDate from '@/components/custom/InputDate'

import vSelect from 'vue-select'
import loading from '@/mixins/Loading.js'

import client from '@/http/requests/client'
import vendor from '@/http/requests/vendor'
import expense from '@/http/requests/expense'
//import company from 'http/request/company'
import debounce from 'lodash/debounce'
export default {
  components: {
    MainSidebar,
    vSelect,
    InputDate,
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    isLoading() {
      return this.loading.clients || this.loading.vendors
    },
    filterClients()
    {
      if( this.filters.company.length === 0){
        return this.clientList
      }
     return this.clientList.filter( (client) => this.filters.company.includes(client.CompanyId) )
    }
  },
  data() {
    return {
      name: 'accounting-search-filter',
      clientList: [],
      companyList: [],
      vendorList: [],
      statusList: [],
      loading: {
        clients: false,
        vendors: false,
        companies: false,
        status: false,
        submit: false,
      },
      filters: {
        status:[],
        company: [],
        client: [],
        vendor: [],
        start_date: '',
        end_date: '',
        folio:''
      },
      
    }
  },
  methods: {
    getClients() {
      this.loading.clients = true
      client
        .list({'all':true})
        .then((res) => {
          this.clientList = res.data.clients
          this.loading.clients = false
        })
        .catch((err) => {
          this.loading.clients = false
        })
    },
    getCompanies() {
      this.loading.companies = true
      expense
        .getCompanies()
        .then((res) => {
          this.companyList = res.data.companies
          this.loading.companies = false
        })
        .catch((err) => {
          this.loading.companies = false
        })
    },
    onSearchVendors(search, loading) {
      if(search.length > 3) {
        loading(true);
       this.getVendors(loading, search, this);
      }
    },
    getVendors:debounce((loading, search, vm) => {
      vendor
        .search({search:search})
        .then((res) => {
          vm.vendorList = [...res.data.vendors,...vm.filters.vendor]
          loading(false);
        })
        .catch((err) => {
          vm.vendorList = []
          loading(false);
        })
      }),
    getStatus() {
      this.loading.status = true
      expense
        .getStatus()
        .then((res) => {
          this.statusList = res.data.status
          this.loading.status = false
        })
        .catch((err) => {
          this.loading.status = false
        })
    },
    init() {

    },
    clear() {
       this.filters = {
        status:[],
        company: [],
        client: [],
        vendor: [],
        start_date: '',
        end_date: '',
        folio:''
      },
      this.$store.dispatch('setGlobalExpensesFilter',null)
      this.$emit('input', this.filters)
      this.close()
    },
    setFilter() {
      if(this.validate()){
        this.$store.dispatch('setGlobalExpensesFilter',null)
        this.$emit('input', this.filters)
        this.close()
      }
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    validate(){
      if(this.filters.start_date.length > 1 && this.filters.start_date.length < 10 ){
        this.filters.start_date = ''
         this.$vs.notify({
            color: 'danger',
            //title: 'Alert',
            text: `Start Date Invalid`
          });
          return false;
      }
      if(this.filters.end_date.length > 1 && this.filters.end_date.length < 10 ){
        this.filters.end_date = ''
         this.$vs.notify({
            color: 'danger',
            text: `End Date Invalid`
          });
          return false;
      }
      return true;
    },
    clearClientSelect(){
      this.filters.client = []
    }
  },
  mixins: [loading],
  mounted(){
      this.getClients()
      //this.getVendors()
      this.getCompanies()
      this.getStatus()
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        invoiced: false,
        pending: true,
        rejected: false,
        status: [],
        vendor: [],
        client: [],
        date: '',
        period: [],
      }),
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
      } else {
        this.closeLoading(`loading-${this.name}-sidebar`)
      }
    },
  },
}
</script>

<style>
.vs__dropdown-menu {
  max-height: 100px;
}
</style>
